<script>
import Mixin from "@utilities/mixin";
import ReportTableBox from "@components/reports/EOD/ReportTableBox.vue";

export default {
  name: "SmogTable",
  components: {ReportTableBox},
  mixins: [Mixin],
  props: {
    editing: Boolean,
    dataTable: Array,
    total: Number,
    totalSales: Number,
  },
  data() {
    return {
      localDataTable: this.dataTable
    }
  },
  watch: {
    localDataTable: {
      handler() {
        this.$emit("updateDataTable", this.localDataTable);
      },
      deep: true
    }
  }
}
</script>

<template>
  <ReportTableBox title="Smog Checks">
    <DataTable :value="dataTable" size="small" class="custom-table w-full">
      <Column field="price">
        <template #header>
          <span class="md:pl-4 pl-0 font-semibold">Price</span>
        </template>
        <template #body="slotProps">
          <span class="md:pl-4 p-0">{{ formatUSD(slotProps.data.price) }}</span>
        </template>
      </Column>
      <Column field="amount">
        <template #header>
          <div class="flex justify-center items-center w-full">
            <span class="text-center font-semibold">Amt</span>
          </div>
        </template>
        <template #body="{data, field}">
          <div class="flex justify-center items-center w-full">
            <InputNumber :min="0" v-if="editing" class="sleek-input" v-model="data[field]" autofocus fluid/>
            <span v-else class="m-0">
            {{ data[field] }}
          </span>
          </div>
        </template>
      </Column>
      <Column field="total">
        <template #header>
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <span class="text-end font-semibold">Charged</span>
          </div>
        </template>
        <template #body="slotProps">
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            {{ formatUSD((parseInt(slotProps.data.amount) * parseFloat(slotProps.data.price)) ?? 0) }}
          </div>
        </template>
      </Column>
      <ColumnGroup type="footer">
        <Row>
          <Column>
            <template #footer>
              <span class="font-semibold md:pl-4 pl-0">Total</span>
            </template>
          </Column>
          <Column>
            <template #footer>
              <div class="flex justify-center items-center w-full">
                <span class="font-semibold text-center">
                  {{ total }}
                </span>
              </div>
            </template>
          </Column>
          <Column>
            <template #footer>
              <div class="flex justify-end items-center w-full md:pr-4 pr-0">
                <span class="font-semibold text-end">
                  {{ formatUSD(totalSales) }}
                </span>
              </div>
            </template>
          </Column>
        </Row>
      </ColumnGroup>
    </DataTable>
  </ReportTableBox>
</template>
